(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const styleId = 'codex-mobile-product-buttons-width';
  let stickyButton = null;
  let activeSubmit = null;
  let scrollTicking = false;

  function ensureStyle() {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media screen and (max-width: 749px) {
        body.codex-sticky-atc-visible {
          padding-bottom: calc(5.8rem + env(safe-area-inset-bottom)) !important;
        }

        product-info .product__info-container > div:has(> product-form),
        [id^='MainProduct-'] product-info .product__info-container > div:has(> product-form) {
          grid-column: 1 / -1 !important;
          justify-self: stretch !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
        }

        product-info .product-form,
        product-info .product-form form,
        product-info .product-form__buttons,
        [id^='MainProduct-'] product-info .product-form,
        [id^='MainProduct-'] product-info .product-form form,
        [id^='MainProduct-'] product-info .product-form__buttons {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
        }

        product-info .product-form__buttons,
        [id^='MainProduct-'] product-info .product-form__buttons {
          display: grid !important;
          grid-template-columns: minmax(8.8rem, 0.52fr) minmax(0, 1fr) !important;
          grid-template-rows: auto auto !important;
          gap: 0.6rem !important;
          justify-content: stretch !important;
          align-items: stretch !important;
          margin-right: 0 !important;
          margin-left: 0 !important;
        }

        product-info .codex-mobile-quantity,
        [id^='MainProduct-'] product-info .codex-mobile-quantity {
          grid-column: 1 !important;
          grid-row: 1 !important;
          display: grid !important;
          grid-template-columns: 2.6rem minmax(0, 1fr) 2.6rem !important;
          align-items: center !important;
          width: 100% !important;
          min-width: 0 !important;
          min-height: 4.2rem !important;
          margin: 0 !important;
          overflow: hidden !important;
          border: 0.1rem solid rgba(0, 0, 0, 0.16) !important;
          border-radius: 0.5rem !important;
          background: rgb(255, 255, 255) !important;
          box-sizing: border-box !important;
        }

        product-info .codex-mobile-quantity button,
        [id^='MainProduct-'] product-info .codex-mobile-quantity button {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          height: 100% !important;
          min-width: 0 !important;
          min-height: 4.2rem !important;
          padding: 0 !important;
          border: 0 !important;
          background: transparent !important;
          color: rgb(0, 0, 0) !important;
          font: inherit !important;
          line-height: 1 !important;
        }

        product-info .codex-mobile-quantity input,
        [id^='MainProduct-'] product-info .codex-mobile-quantity input {
          width: 100% !important;
          min-width: 0 !important;
          height: 100% !important;
          min-height: 4.2rem !important;
          padding: 0 !important;
          border: 0 !important;
          background: transparent !important;
          color: rgb(0, 0, 0) !important;
          font: inherit !important;
          line-height: 1 !important;
          text-align: center !important;
          appearance: textfield !important;
          -moz-appearance: textfield !important;
        }

        product-info .codex-mobile-quantity input::-webkit-outer-spin-button,
        product-info .codex-mobile-quantity input::-webkit-inner-spin-button {
          margin: 0 !important;
          appearance: none !important;
          -webkit-appearance: none !important;
        }

        product-info .product-form__submit,
        [id^='MainProduct-'] product-info .product-form__submit {
          grid-column: 2 !important;
          grid-row: 1 !important;
          width: 100% !important;
          max-width: 100% !important;
          justify-self: stretch !important;
        }

        product-info .shopify-payment-button,
        [id^='MainProduct-'] product-info .shopify-payment-button {
          display: block !important;
          grid-column: 1 / -1 !important;
          grid-row: 2 !important;
          width: 100% !important;
          max-width: 100% !important;
          justify-self: stretch !important;
        }

        product-info .product-form__buttons > *:not(.codex-mobile-quantity),
        product-info .product-form__buttons button:not(.codex-mobile-quantity__button),
        product-info .product-form__buttons shopify-payment-button,
        product-info .product-form__buttons shopify-accelerated-checkout,
        product-info .product-form__buttons shopify-paypal-button,
        product-info .product-form__buttons .paypal-buttons,
        product-info .product-form__buttons .component-frame {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
        }

        .codex-sticky-add-to-cart {
          position: fixed !important;
          left: max(1.5rem, env(safe-area-inset-left)) !important;
          right: max(1.5rem, env(safe-area-inset-right)) !important;
          bottom: max(1rem, env(safe-area-inset-bottom)) !important;
          z-index: 70 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: auto !important;
          min-height: 4.4rem !important;
          margin: 0 !important;
          padding: 0 1.8rem !important;
          border: 0 !important;
          border-radius: 0.5rem !important;
          background: rgb(0, 0, 0) !important;
          color: rgb(255, 255, 255) !important;
          box-shadow: 0 0.8rem 2.4rem rgba(0, 0, 0, 0.12) !important;
          opacity: 0 !important;
          pointer-events: none !important;
          transform: translateY(1.2rem) !important;
          transition: opacity 160ms ease, transform 160ms ease !important;
          box-sizing: border-box !important;
        }

        .codex-sticky-add-to-cart.is-visible {
          opacity: 1 !important;
          pointer-events: auto !important;
          transform: translateY(0) !important;
        }
      }

      @media screen and (min-width: 750px) {
        body.codex-sticky-atc-visible {
          padding-bottom: 0 !important;
        }

        .codex-sticky-add-to-cart {
          display: none !important;
        }

        product-info .product__info-container > div:has(> product-form),
        [id^='MainProduct-'] product-info .product__info-container > div:has(> product-form) {
          grid-column: 2 !important;
          justify-self: end !important;
          width: 36rem !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
        }

        product-info .product-form,
        product-info .product-form form,
        product-info .product-form__buttons,
        [id^='MainProduct-'] product-info .product-form,
        [id^='MainProduct-'] product-info .product-form form,
        [id^='MainProduct-'] product-info .product-form__buttons {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
        }

        product-info .product-form__buttons,
        [id^='MainProduct-'] product-info .product-form__buttons {
          display: grid !important;
          grid-template-columns: minmax(8.8rem, 0.52fr) minmax(0, 1fr) !important;
          grid-template-rows: auto auto !important;
          gap: 0.6rem !important;
          align-items: stretch !important;
          justify-content: stretch !important;
          margin-right: 0 !important;
          margin-left: 0 !important;
        }

        product-info .codex-mobile-quantity,
        [id^='MainProduct-'] product-info .codex-mobile-quantity {
          grid-column: 1 !important;
          grid-row: 1 !important;
          display: grid !important;
          grid-template-columns: 2.6rem minmax(0, 1fr) 2.6rem !important;
          align-items: center !important;
          width: 100% !important;
          min-width: 0 !important;
          min-height: 4.2rem !important;
          margin: 0 !important;
          overflow: hidden !important;
          border: 0.1rem solid rgba(0, 0, 0, 0.16) !important;
          border-radius: 0.5rem !important;
          background: rgb(255, 255, 255) !important;
          box-sizing: border-box !important;
        }

        product-info .codex-mobile-quantity button,
        [id^='MainProduct-'] product-info .codex-mobile-quantity button {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          height: 100% !important;
          min-width: 0 !important;
          min-height: 4.2rem !important;
          padding: 0 !important;
          border: 0 !important;
          background: transparent !important;
          color: rgb(0, 0, 0) !important;
          font: inherit !important;
          line-height: 1 !important;
        }

        product-info .codex-mobile-quantity input,
        [id^='MainProduct-'] product-info .codex-mobile-quantity input {
          width: 100% !important;
          min-width: 0 !important;
          height: 100% !important;
          min-height: 4.2rem !important;
          padding: 0 !important;
          border: 0 !important;
          background: transparent !important;
          color: rgb(0, 0, 0) !important;
          font: inherit !important;
          line-height: 1 !important;
          text-align: center !important;
          appearance: textfield !important;
          -moz-appearance: textfield !important;
        }

        product-info .codex-mobile-quantity input::-webkit-outer-spin-button,
        product-info .codex-mobile-quantity input::-webkit-inner-spin-button {
          margin: 0 !important;
          appearance: none !important;
          -webkit-appearance: none !important;
        }

        product-info .product-form__submit,
        [id^='MainProduct-'] product-info .product-form__submit {
          grid-column: 2 !important;
          grid-row: 1 !important;
          width: 100% !important;
          max-width: 100% !important;
          justify-self: stretch !important;
        }

        product-info .shopify-payment-button,
        [id^='MainProduct-'] product-info .shopify-payment-button {
          display: block !important;
          grid-column: 1 / -1 !important;
          grid-row: 2 !important;
          width: 100% !important;
          max-width: 100% !important;
          justify-self: stretch !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function setSizing(element, values) {
    if (!element) return;
    Object.entries(values).forEach(([property, value]) => {
      element.style.setProperty(property, value, 'important');
    });
  }

  function ensureQuantityControl(buttonGroup) {
    let quantity = buttonGroup.querySelector('.codex-mobile-quantity');
    if (!quantity) {
      quantity = document.createElement('div');
      quantity.className = 'codex-mobile-quantity';
      quantity.innerHTML = `
        <button class="codex-mobile-quantity__button" type="button" aria-label="Decrease quantity">-</button>
        <input class="codex-mobile-quantity__input" type="number" name="quantity" value="1" min="1" inputmode="numeric" aria-label="Quantity">
        <button class="codex-mobile-quantity__button" type="button" aria-label="Increase quantity">+</button>
      `;
      buttonGroup.prepend(quantity);
    }

    const input = quantity.querySelector('input');
    quantity.querySelectorAll('button').forEach((button) => {
      button.onclick = () => {
        const current = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = button.textContent.trim() === '+' ? current + 1 : Math.max(1, current - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
    });

    return quantity;
  }

  function ensureStickyButton() {
    if (stickyButton) return stickyButton;

    stickyButton = document.createElement('button');
    stickyButton.className = 'codex-sticky-add-to-cart';
    stickyButton.type = 'button';
    stickyButton.addEventListener('click', () => {
      if (!activeSubmit || activeSubmit.disabled) return;
      activeSubmit.click();
    });
    document.body.appendChild(stickyButton);

    return stickyButton;
  }

  function hideStickyButton() {
    document.body.classList.remove('codex-sticky-atc-visible');
    if (stickyButton) stickyButton.classList.remove('is-visible');
  }

  function syncStickyButton(submit) {
    const sticky = ensureStickyButton();
    activeSubmit = submit;
    sticky.innerHTML = submit.innerHTML;
    sticky.disabled = submit.disabled;
    sticky.setAttribute('aria-label', submit.getAttribute('aria-label') || submit.textContent.trim() || 'Add to cart');
    updateStickyButton();
  }

  function updateStickyButton() {
    if (!mobileQuery.matches || !activeSubmit || activeSubmit.disabled) {
      hideStickyButton();
      return;
    }

    const submitRect = activeSubmit.getBoundingClientRect();
    const productInfo = activeSubmit.closest('product-info');
    const productRect = productInfo ? productInfo.getBoundingClientRect() : null;
    const showSticky = submitRect.bottom < 0 && (!productRect || productRect.bottom > window.innerHeight + 60);

    document.body.classList.toggle('codex-sticky-atc-visible', showSticky);
    ensureStickyButton().classList.toggle('is-visible', showSticky);
  }

  function scheduleStickyUpdate() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(() => {
      scrollTicking = false;
      updateStickyButton();
    });
  }

  function applyMobile(container) {
    const formWrapper = [...container.children].find((child) => child.querySelector(':scope > product-form'));
    if (!formWrapper) return;

    setSizing(formWrapper, {
      'grid-column': '1 / -1',
      'justify-self': 'stretch',
      width: '100%',
      'max-width': '100%',
      'min-width': '0',
      'box-sizing': 'border-box',
    });

    const productForm = formWrapper.querySelector('product-form');
    const form = formWrapper.querySelector('form');
    const buttonGroup = formWrapper.querySelector('.product-form__buttons');
    [productForm, form, buttonGroup].forEach((element) => setSizing(element, {
      width: '100%',
      'max-width': '100%',
      'min-width': '0',
      'box-sizing': 'border-box',
    }));

    if (!buttonGroup) return;
    const quantity = ensureQuantityControl(buttonGroup);
    setSizing(buttonGroup, {
      display: 'grid',
      'grid-template-columns': 'minmax(8.8rem, 0.52fr) minmax(0, 1fr)',
      'grid-template-rows': 'auto auto',
      gap: '0.6rem',
      'justify-content': 'stretch',
      'align-items': 'stretch',
      'margin-right': '0',
      'margin-left': '0',
    });

    setSizing(quantity, {
      'grid-column': '1',
      'grid-row': '1',
      display: 'grid',
      width: '100%',
      'min-width': '0',
      'min-height': '4.2rem',
      margin: '0',
    });

    const submit = buttonGroup.querySelector('.product-form__submit');
    setSizing(submit, {
      'grid-column': '2',
      'grid-row': '1',
      width: '100%',
      'max-width': '100%',
    });

    setSizing(buttonGroup.querySelector('.shopify-payment-button'), {
      'grid-column': '1 / -1',
      'grid-row': '2',
      width: '100%',
      'max-width': '100%',
    });

    if (submit) syncStickyButton(submit);
  }

  function applyDesktop(container) {
    const formWrapper = [...container.children].find((child) => child.querySelector(':scope > product-form'));
    if (!formWrapper) return;

    hideStickyButton();

    setSizing(formWrapper, {
      'grid-column': '2',
      'justify-self': 'end',
      width: '36rem',
      'max-width': '100%',
      'min-width': '0',
      'box-sizing': 'border-box',
    });

    const productForm = formWrapper.querySelector('product-form');
    const form = formWrapper.querySelector('form');
    const buttonGroup = formWrapper.querySelector('.product-form__buttons');
    [productForm, form, buttonGroup].forEach((element) => setSizing(element, {
      width: '100%',
      'max-width': '100%',
      'min-width': '0',
      'box-sizing': 'border-box',
    }));

    if (!buttonGroup) return;
    const quantity = ensureQuantityControl(buttonGroup);
    setSizing(buttonGroup, {
      display: 'grid',
      'grid-template-columns': 'minmax(8.8rem, 0.52fr) minmax(0, 1fr)',
      'grid-template-rows': 'auto auto',
      gap: '0.6rem',
      'justify-content': 'stretch',
      'align-items': 'stretch',
      'margin-right': '0',
      'margin-left': '0',
    });

    setSizing(quantity, {
      'grid-column': '1',
      'grid-row': '1',
      display: 'grid',
      width: '100%',
      'min-width': '0',
      'min-height': '4.2rem',
      margin: '0',
    });

    setSizing(buttonGroup.querySelector('.product-form__submit'), {
      'grid-column': '2',
      'grid-row': '1',
      width: '100%',
      'max-width': '100%',
    });

    setSizing(buttonGroup.querySelector('.shopify-payment-button'), {
      'grid-column': '1 / -1',
      'grid-row': '2',
      width: '100%',
      'max-width': '100%',
    });
  }

  function applyProductButtonLayout() {
    ensureStyle();
    document.querySelectorAll('product-info .product__info-container').forEach((container) => {
      if (mobileQuery.matches) {
        applyMobile(container);
      } else {
        applyDesktop(container);
      }
    });
    updateStickyButton();
  }

  applyProductButtonLayout();
  document.addEventListener('DOMContentLoaded', applyProductButtonLayout, { once: true });
  document.addEventListener('change', () => window.setTimeout(applyProductButtonLayout, 50));
  document.addEventListener('click', () => window.setTimeout(applyProductButtonLayout, 50));
  window.setTimeout(applyProductButtonLayout, 150);
  window.setTimeout(applyProductButtonLayout, 600);
  window.setTimeout(applyProductButtonLayout, 1400);
  window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
  window.addEventListener('resize', applyProductButtonLayout);
  mobileQuery.addEventListener?.('change', applyProductButtonLayout);
})();
